import React from 'react';
import SearchProjectOption from "./search-results/project-option";
import SearchViewOption from "./search-results/view-option";
import SearchUserOption from "./search-results/user-option";
import SearchTaskOption from "./search-results/task-option";
import SearchNoteOption from "./search-results/note-option";
import SearchSettingOption from "./search-results/setting-option";

type Props = {
    noMatches           : boolean
    isGuest             : boolean
    isCustomerPortal    : boolean
    isSearching         : boolean

    projects            : any[]
    views               : any[]
    users               : any[]
    tasks               : any[]
    notes               : any[]
    settings            : any[]

    getProjectKey       : callback
    getViewKey          : callback
    getUserKey          : callback
    getTaskKey          : callback
    getNoteKey          : callback
    getSettingKey       : callback
    onCloseModal?       : callback
    getCurrentOptionKey : callback
}

export default function SearchList(props: Props) {

    const renderProjects = ()=> {
        const selectedKey = props.getCurrentOptionKey();
        return props.projects.map((p: any)=>{
            const key = props.getProjectKey(p);
            return <SearchProjectOption key         = {gd.utils.generateUUID()}
                                        project     = {p}
                                        isSelected  = {key === selectedKey}
                                        onClick     = {onClickProject}/>
        })
    }

    const renderViews = ()=> {
        const selectedKey = props.getCurrentOptionKey();
        return props.views.map((v: any)=>{
            const key = props.getViewKey(v);
            return <SearchViewOption key        = {gd.utils.generateUUID()}
                                     view       = {v}
                                     isSelected = {key === selectedKey}
                                     onClick    = {onClickView}/>
        })
    }

    const renderUsers = ()=> {
        const selectedKey = props.getCurrentOptionKey();
        return props.users.map((cu: any)=>{
            const key = props.getUserKey(cu);
            return <SearchUserOption key            = {gd.utils.generateUUID()}
                                     companyUser    = {cu}
                                     isSelected     = {key === selectedKey}
                                     onClick        = {onClickUser}/>
        })
    }

    const renderTasks = ()=> {
        if (!props.isSearching) {
            const selectedKey = props.getCurrentOptionKey();
            return props.tasks.map((t: any)=>{
                const key = props.getTaskKey(t);
                return <SearchTaskOption key        = {gd.utils.generateUUID()}
                                         task       = {t}
                                         isSelected = {key === selectedKey}
                                         onClick    = {onClickTask}/>
            })
        }
    }

    const renderNotes = ()=> {
        if (!props.isSearching) {
            const selectedKey = props.getCurrentOptionKey();
            return props.notes.map((n: any)=>{
                const key = props.getNoteKey(n);
                return <SearchNoteOption key        = {gd.utils.generateUUID()}
                                         note       = {n}
                                         isSelected = {key === selectedKey}
                                         onClick    = {onClickNote}/>
            })
        }
    }

    const renderSettings = ()=> {
        if (_.isEmpty(props.settings)) return

        const selectedKey = props.getCurrentOptionKey();
        return props.settings.map((s: any)=>{
            const key = props.getSettingKey(s);
            return <SearchSettingOption key         = {gd.utils.generateUUID()}
                                        setting     = {s}
                                        isSelected  = {key === selectedKey}
                                        onClick     = {onClickSetting}/>
        })
    }

    const renderSearching = ()=>  {
        return props.isSearching && (
            <div className="flex-row-center-center w-100-percent h-42 ui5-txt-no-accent-default">
                Searching...
            </div>
        )
    }

    const onClickProject = (id: ID) =>                {
        if(props.onCloseModal) props.onCloseModal();
        gd.goTo('p/'+id);
    }
    const onClickView = (id: ID, type: ID) =>         {
        if(props.onCloseModal) props.onCloseModal();
        gd.goTo('v/'+type+'/'+id);
    }
    const onClickUser = (companyUserId: ID) =>        {
        if(props.onCloseModal) props.onCloseModal();
        gd.goTo('u/'+companyUserId);
    }
    const onClickTask = (id: ID) =>                   {
        if(props.onCloseModal) props.onCloseModal();
        gd.goTo('t/'+id);
    }
    const onClickNote = (id: ID) =>                   {
        if(props.onCloseModal) props.onCloseModal();
        gd.goTo('n/'+id);
    }
    const onClickSetting = (url: string) =>           {
        if(props.onCloseModal) props.onCloseModal();
        gd.goTo(url)
    }



    return (
        <>
            <div className="ui5-list h-40">

                {renderProjects()}

                {!props.isCustomerPortal && renderViews()}

                {!props.isCustomerPortal && !props.isGuest && renderUsers()}

                {renderTasks()}

                {renderNotes()}

                {!props.isCustomerPortal && renderSettings()}

                {props.noMatches && (
                    <div className="flex-row-center-center w-100-percent h-42 ui5-txt-no-accent-default">
                        No match found
                    </div>
                )}

            </div>

            {renderSearching()}
        </>
    );
}
